/**
 * Copyright 2017 Taito United Oy
 * All rights reserved.
 */

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import { stringify } from 'query-string';
import { start } from '~actions'; // eslint-disable-line
import { getApiUrl } from '~services/utils'; // eslint-disable-line

// Containers
import App from './app';
import Widget from './features/widget/widget.container';
import Portfolio from './features/paid/PortfolioSeparate';
import LicenseManagement from './features/license/licensetable.container';

const privateRoute = ({
  component: RouteComponent, session, locale, ...rest
}) =>
  <Route {...rest} render={props => {
    if (
      Object.keys(session.logins).length > 0
      && RouteComponent.isAuthorized(props, session)
    ) {
      return <RouteComponent {...props} />;
    } else if (
      session.state === session.states.LOGGING_IN
      || !session.tokenLoginChecked) {
      return null;
    }
    const loginParams = stringify({
      locale,
      postGluuLoginRedirectUrl: props.location.pathname,
    });
    window.location.href = `${getApiUrl()}/authenticate/login?${loginParams}`;
    return null;
  }} />;
privateRoute.propTypes = {
  component: PropTypes.func.isRequired,
  locale: PropTypes.string,
  location: PropTypes.object.isRequired,
  session: PropTypes.object.isRequired,
};
const PrivateRoute =
  connect(state => ({
    locale: state.locale.lang,
    session: state.session,
  }))(privateRoute);
export { PrivateRoute };

const propTypes = {
  start: PropTypes.func.isRequired,
  locale: PropTypes.object.isRequired,
};

class RoutesWrapper extends Component {
  componentDidMount() {
    const { locale } = this.props;
    moment.locale(locale.lang);
    this.props.start();
  }

  componentDidUpdate() {
    const { locale } = this.props;
    moment.locale(locale.lang);
  }

  render() {
    return (
      <Router>
        <React.Fragment>
          <Switch>
            <PrivateRoute
              path="/lisenssit"
              component={LicenseManagement}
            />
            <Route
              path="/selvitys/widget/embed/:country/:identifier"
              component={Widget}
            />
            <Route
              path="/selvitys/esite/:country/:identifier"
              component={Portfolio}
            />
            <Route path="/selvitys" component={App} />
          </Switch>
        </React.Fragment>
      </Router>
    );
  }
}

RoutesWrapper.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    locale: state.locale,
  };
}

// This adds action creators to components props
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      start,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(RoutesWrapper);
